"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const graphql_1 = require("../../../../graphql");
const react_hooks_1 = require("@apollo/react-hooks");
const react_if_1 = require("react-if");
const hooks_1 = require("../../hooks");
const react_2 = require("@osmosys/react");
exports.EmailCanvasUpgradeTemplate = () => {
    const { canvasQueries: { email }, state: { draftEmail: draft }, } = hooks_1.useEmailCanvasContext();
    const { data: { canUpgradeToProdTemplateVersion, canUpgradeToStageTemplateVersion }, } = hooks_1.useEmailCanvasCanvas('meta');
    // Mutation:
    const [mutate, result] = react_hooks_1.useMutation(graphql_1.updateEmailToNewTemplateVersion, {
        onCompleted: () => {
            email.result.refetch();
        },
        variables: {
            id: draft.id,
            type: 'production',
        },
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_if_1.When, { condition: canUpgradeToProdTemplateVersion }, () => (react_1.default.createElement("div", null,
            react_1.default.createElement(react_2.OsmosysButton, { osysName: "EmailCanvasUpgradeTemplate", mutate: () => {
                    mutate({
                        variables: {
                            id: draft.id,
                            type: 'production',
                        },
                    });
                }, mutationResult: result, color: "warning", osysIcon: "deploy", className: "mt-2", size: "sm", renderApolloError: true },
                "Upgrade to Production",
                ' ',
                draft.emailTemplateVersion.template.productionVersion.version)))),
        react_1.default.createElement(react_if_1.When, { condition: canUpgradeToStageTemplateVersion }, () => (react_1.default.createElement("div", null,
            react_1.default.createElement(react_2.OsmosysButton, { osysName: "EmailCanvasUpgradeTemplate", mutate: () => mutate({
                    variables: {
                        id: draft.id,
                        type: 'staging',
                    },
                }), mutationResult: result, color: "warning", osysIcon: "deploy", className: "mt-2", renderApolloError: true, size: "sm" },
                "Upgrade to Staging version",
                ' ',
                draft.emailTemplateVersion.template.stagingVersion.version))))));
};
//# sourceMappingURL=EmailCanvasUpgradeTemplate.js.map